import { PlugZap } from 'lucide-react'

/**
 * État « fonctionnalité non active » pour une surface du builder dont le back
 * n'est pas disponible (module Drupal désactivé). Résilience : on affiche ce
 * message au lieu de tenter de rendre des données qui n'existent pas.
 *
 * Ébauche d'un futur système de « capabilities » : pour l'instant l'appelant
 * déduit l'indisponibilité de l'échec de l'endpoint ; à terme un flag de
 * capacité (ex. /api/orbit/capabilities) pilotera cet affichage de façon
 * explicite.
 */
export const FeatureUnavailable = ({ title, detail }) => (
  <div className="flex flex-col items-center justify-center py-24 text-center">
    <div className="w-16 h-16 bg-gray-100 rounded-2xl flex items-center justify-center mb-6">
      <PlugZap size={28} className="text-gray-400" />
    </div>
    <h1 className="text-xl font-semibold text-gray-700 mb-2">{title}</h1>
    <p className="text-sm text-gray-400 max-w-sm">{detail}</p>
  </div>
)
